import { WarehouseTask__ActionType } from '@admin/schema';

export const ACTION_TYPE_LABELS: Record<WarehouseTask__ActionType, string> = {
  [WarehouseTask__ActionType.MissingLabelsOnBox]: 'Missing Labels on Box',
  [WarehouseTask__ActionType.SearchInBox]: 'Search for Something in Box/Item',
  [WarehouseTask__ActionType.UnwrapPreWrapPhoto]: 'Unwrap Item and Take Pre-wrap Photos',
  [WarehouseTask__ActionType.PoorQualityPhotos]: 'Poor Quality Photos',
  [WarehouseTask__ActionType.Measurements]: 'Measurements',
  [WarehouseTask__ActionType.CategoryChange]: 'Item Category Change',
  [WarehouseTask__ActionType.RepackNoNewItem]: 'Repack (No New Item)',
  [WarehouseTask__ActionType.RepackSeparateItems]: 'Repack (Separate Items)',
};

export const ACTION_GROUP_LABELS: Record<string, string> = {
  reshoot: 'Reshoot',
  item_details: 'Item Details',
  repack: 'Repack',
};

export const ACTIONS_BY_GROUP: Record<string, WarehouseTask__ActionType[]> = {
  reshoot: [
    WarehouseTask__ActionType.MissingLabelsOnBox,
    WarehouseTask__ActionType.SearchInBox,
    WarehouseTask__ActionType.UnwrapPreWrapPhoto,
    WarehouseTask__ActionType.PoorQualityPhotos,
  ],
  item_details: [WarehouseTask__ActionType.Measurements, WarehouseTask__ActionType.CategoryChange],
  repack: [WarehouseTask__ActionType.RepackNoNewItem, WarehouseTask__ActionType.RepackSeparateItems],
};

export const STATE_LABELS: Record<string, string> = {
  PENDING: 'Pending',
  IN_PROGRESS: 'In Progress',
  COMPLETED: 'Completed',
  CANCELED: 'Canceled',
};

export const stateClass = (state: string) => {
  switch (state) {
    case 'PENDING':
      return 'label-primary';
    case 'IN_PROGRESS':
      return 'label-warning';
    case 'COMPLETED':
      return 'label-success';
    case 'CANCELED':
      return 'label-default';
    default:
      return 'label-info';
  }
};
